import {isDescendant} from '../../../../../common/action-flows/config/step-traversal'
import {
  ActionFlowConfig,
  ActionFlowStep,
  CreateCardStep
} from '../../../../../common/types/action-flows'

export const getCardTemplateSteps = (
  config: ActionFlowConfig,
  cardTemplateId: string
): ActionFlowStep[] => {
  return Object.values(config.steps).filter(
    step =>
      step.type === 'create-card' &&
      step.properties.cardTemplateId === cardTemplateId
  )
}

export const getCardCount = (config: ActionFlowConfig) => {
  return config?.cardTemplates ? Object.keys(config.cardTemplates).length : 0
}

export const getPreviousStepsOfType = (
  steps: ActionFlowConfig['steps'],
  stepType: ActionFlowStep['type'],
  previousStepIds: string[]
) => {
  return Object.values(steps).filter(
    (s): s is CreateCardStep =>
      s.type === stepType &&
      //prevent the selection of _subsequent_ cards
      // e.g. create-cards steps that come after this card action step should be excluded
      previousStepIds.every(
        parentId => !isDescendant(steps, parentId, s.id) // check each step is not a descendent
      )
  )
}

export const getVariableCounts = (
  variableNames: string[],
  definition: ActionFlowConfig
): Record<string, number> => {
  const config = JSON.stringify(definition)
  return variableNames.reduce((acc, name) => {
    const res = config.match(RegExp(`%{${name}}|"source":\\s*"${name}"`, 'g'))
    return {
      ...acc,
      [name]: res ? res.length : 0
    }
  }, {})
}
